import React from 'react';
import { PropTypes } from 'prop-types';

import ReactDOM from 'react-dom'
import classNames from 'classnames';

//import { StyleSheet,  View, Image, Text, TextInput, } from 'react-native';

//import { Paper,RaisedButton, FlatButton, FloatingActionButton, TouchableRipple, Icon, themes, IconToggle, gu} from 'carbon-ui'
import { platformHandler } from '../platforms/PlatformHandler'
import { languageManager } from '../utils/languageManager'
//import { Platform } from 'react-native';
//import { em, sizeResponsive, getValuePlatform, sizeResponsiveLandscape } from "../utils/FWResponsive";
import { connect }  from 'react-redux';
import { setSlidePreview,setPresentationModeConfig} from '../App/actions';

import { COLOR }           from '../App/constants';
import WebViewFW from '../components/flipwitComponents/WebViewFW';
import FwModalLoader from '../components/FwModalLoader';
//import Loader from '../components/flipwitComponents/Loader';
import { PluginHandler } from '../utils/pluginHandler';
//import { Actions } from 'react-native-router-flux';
import * as Hammer from 'hammerjs';
import Clock     from '../components/Clock';
//import { CirclePicker } from 'react-color'


import LiterallyCanvas from '../utils/literallycanvas-core'
//
//import LiterallyCanvas from 'literallycanvas'
//import { LiterallyCanvas } from "literallycanvas/lib/js/core/LiterallyCanvas";

import {FwScene} from './FwScene'
import { withStyles } from '@material-ui/core/styles';
import CardMedia from '@material-ui/core/CardMedia';
import { selectCurrentData } from '../App/selectors';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import Slide from '@material-ui/core/Slide';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import BrushIcon from '@material-ui/icons/Brush';
import FormatShapesIcon from '@material-ui/icons/FormatShapes';
import CropSquareIcon from '@material-ui/icons/CropSquare';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUncheckedOutlined';
import Brightness1Icon from '@material-ui/icons/Brightness1';
import UndoIcon from '@material-ui/icons/Undo';
import RedoIcon from '@material-ui/icons/Redo';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import GroupIcon from '@material-ui/icons/Group';

import EraserSvg from '../components/svg/EraserSvg';
import WhiteboardSvg from '../components/svg/WhiteboardSvg';


import FW_ColorPicker from '../components/FW_ColorPicker'

import { FwTutorialClass } from '../components/FwTutorialClass'

const webViewsPrueba = {
	//Este es el que se muestra dentro de la vista de videoBeam cuando no esta en modo fullscreen
	//view: VideoBeam, fullscreen: No
	//urlFinalViewerMinimizado:"http://192.168.1.53:3002",
  
	//Este es la que se muestra grande cuando uno abre un HotPlugin
	//view: Toda la pantalla del exhibitor en el celular
	//urlFinalHotPluginLocalDesdeMenu: "http://192.168.1.53:3001",
  
	//Este es la que se muestra dentro del viewer cuando hay un hotPluginInView
	//view: En el lugar del view, no se si el videobean y no se si en fullscreen
	//urlFinalHotPluginInView: "http://192.168.56.1:3001"
  };
  

const styles = theme => ({  
	flipwitContent: {
	    height: `${window.innerHeight - 64}px`,
	    display: 'flex',    
	    //justifyContent: 'center',
	    alignItems: 'center',
	    flexWrap: 'nowrap',    
	    flexDirection: 'column',     
	    width: '100%',
	    alignSelf: 'flex-start',
    	//marginTop: 32,

		'@media (orientation: landscape)': {
	      	flexDirection: 'row',
	    }	    
	},  

	media: {
		width: '100%',  		
    	//height: '100%',
    	height: '100%',
    	backgroundSize: 'contain',
    	position: 'relative',
    	display: 'flex',
    	alignItems: 'center',
	}, 	

	imgContainer: {
		width: '100%',		
		//height: '100%',		
	},

	allContainers: {
		//width: '96%',
		backgroundColor: 'white',
		borderBottom: '1px solid #AAA',		
	},

	slideContainer: {		
		height: '60%',
	},
	notesContainer: {		
		display: 'flex',
		height: "calc( 100% - 150px )",
		overflow: "auto",
	},
	navButtonContainer: {		
		//height: '20%',		
		maxHeight: 150,
		minHeight: '15%',
		display: 'flex',    
    	alignItems: 'center',
    	justifyContent: 'flex-end',
	},

	slideImgContainer: {
		//height: 'calc(100% - 50px)',
		//borderBottom: '1px solid #AAA',		
		width: "100%",
		backgroundColor: '#EEEEEE',		
		display: 'flex',
		position: 'relative',
		filter: 'drop-shadow(0px 0px 1px rgba(0,0,0,0.3)) drop-shadow(0px 0px 10px rgba(0,0,0,0.3))',
		flexDirection: "column",
		//height: '100%',
	},

	slideBarContainer: {
		height: '50px',
		display: 'flex',
    	alignItems: 'center',    	
    	padding: 5,
    	justifyContent: 'space-between',
    	minHeight: "2em",
    	'@media (max-height: 500px)': {   
            height: 'auto',
            padding: 2,
     	}
	}, 

	drawer:{
		position: 'absolute',
		height: '100%',
		left: 0,
		top: 0,
		right: 0,
		bottom: 0,
	},

	hiddenImg: {
		width: '100%',
    	height: '100%',
    	objectFit: 'contain',
		//visibility: 'hidden',
	},
	
	downBoxContainer: {
		height: '100%',
    	width: '100%',
    	display: 'flex',
    	flexDirection: 'column',    	
	},

	bigBoxContainers: {
		//margin: '5px', 
		height: '100%',
    	width: '100%',
    	display: 'flex',
    	flexDirection: 'column',
        justifyContent: 'center',
		borderBottom: '1px solid #AAA',	
        //height: 'auto',

		'@media (orientation: landscape)': {
	      	flexDirection: 'row',
	    }	
	},

	bordersNoTop: {
		//margin: '2%',
		marginTop: '0',
		width: '100%',
		//height: '100%',
		flex: 1,
	},

	paperDialog: {      
      width: '100%', 
      height: '100%', 
      maxWidth: 'calc(100% - 4px)',
      maxHeight: 'calc(100% - 4px)',      
      margin: 0,
      display: 'flex',      
    },

    paperDialogLandscape: {
    	flexDirection: 'row',
    },

    fullImgContainer: {
		width: '100%', 
		//height: "100%",
		'@media (orientation: landscape)': {
			alignItems: 'center',	      	
	      	height: 'calc(100% - 48px)',
	      	display: 'flex',
	    }	
    },

	drawToolsContainer: {
		//height: '100%',
		display: 'flex',
		flexDirection: 'column',
		//minHeight: 150,
		minHeight: 215,
		flex: '1 1 0px',		
	},

	drawToolsContainerLandscape: {
		alignItems: 'flex-start',
      	flexDirection: 'column',
      	flex: 'none',
      	display: 'flex',
	},

    toolsContainer: {
		display: 'flex',
    	justifyContent: 'space-evenly',
    	margin: '0 5px',
    	flex: 1,
    	alignItems: 'center',  
    	flexWrap: 'wrap',
    	'@media (orientation: landscape)': {
    		flex: 'none',
			alignItems: 'flex-start',
	      	flexDirection: 'column',
	      	margin: 'auto',
	    }	
    },

	toolIconButton: {
	    minWidth: 58,
	    minHeight: 40,
	    padding: '6px 16px',
	    margin: 'auto',
	    marginTop: 5,
	    marginBottom: 0,
		'@media (orientation: landscape)': {
	    	width: 60,
	    	fontSize: '0.7em',	
	    }	
	},

	toolIconButtonWhiteBoard: {
	    height: '40%',
	    minWidth: 165,
	    marginTop: 5,	
	    '@media (orientation: landscape)': {
	    	minWidth: 'unset', 
	    	width: 60,
	    	fontSize: '0.7em',
	    },	        
	},

	toolIconButtonOption: {
	    width: 74,
	    height: 40,	    
	    padding: '6px 16px',
	    margin: 6,
	},

	windowBar: {
		backgroundColor: COLOR.FLIPWIT_COLOR_1,
		width: '100%',		
		color: 'white',
		height: "64px",
		display: 'flex',
    	alignItems: 'center',
	},

	title: {
	    fontSize: '1.1em',
	    fontFamily: 'Roboto-Medium',
	    fontWeight: 400,
	    margin: "8px 0px",
	},    

	button: {
		backgroundColor: COLOR.FLIPWIT_COLOR_1,
    	color: 'white',    
    	width: '80%',
    	height: '40%',	
    	margin: 'auto',
    	marginTop: 5,
    	marginBottom: 0,
    	'&:hover': {
      		backgroundColor: COLOR.FLIPWIT_COLOR_2,
     	}  
	},

	buttonClear: {
		backgroundColor: 'white',
    	color: COLOR.FLIPWIT_COLOR_1,    
    	borderColor: COLOR.FLIPWIT_COLOR_1,
    	//width: '80%',
    	height: '40%',	
    	minWidth: 165,
	    minHeight: 40,
	    padding: '6px 16px',
	    margin: 'auto',
	    marginTop: 5,
	    marginBottom: 0,
    	'&:hover': {
      		backgroundColor: COLOR.FLIPWIT_COLOR_4,
      		color: 'white', 
     	},  

		'@media (orientation: landscape)': {
    		minWidth: 'unset', 
    		width: 60,
    		fontSize: '0.7em',
	    },	
     	
	},

	optionToolImg: {
		marginLeft: 4,
	},

	optionToolColorImg: {
		marginLeft: 4,
		borderRadius:'50%', 
		border:'1px solid black',
	},

	paperOptionsDialog: {
		
	},

	paperTitle: {
      backgroundColor: COLOR.FLIPWIT_COLOR_2,
      color: 'black',
      //height: '17%',
      display: 'flex',
      alignItems: 'center',      
      width: '100%',
      overflow: 'hidden',
      flexShrink: 0,
    }, 
	labelTitlePaper: {
      display: 'flex',
      alignItems: 'inherit',
      fontSize: '1.3em',
      color: 'white',
      margin: theme.spacing.unit+"px "+(theme.spacing.unit*2)+'px',
      overflow: 'hidden',
    },
	menuButton: {
      color: 'white',
      marginLeft: theme.spacing.unit,     
    },  

    optionsSelectionContainer: {
		display: 'flex',
    	margin: 12,
    	flexWrap: 'wrap',
    	justifyContent: 'center',
    	maxWidth: 'initial',
    	overflow: 'hidden',
    },

    thicknessPreviewDiv: {
    	width: 35,
    	height: 35,
    	display: 'flex',
    	alignItems: 'center',
    	justifyContent: 'center',
    },

	fwSvg: {
		userSelect: 'none',
		width: '1em',
		height: '1em',
		fontSize: 24,
		marginLeft: 6,
	},

	svgHide: {
		['@media (orientation: landscape)']: {
    		display: 'none',
	    },	
	},

	labelSpan: {
		['@media (orientation: landscape)']: {
    		display: 'flex',
    		flexDirection: 'column',
	    },		
	},

	enclosingDivs: {
		width: '50%',
    	display: 'flex',
    	justifyContent: 'center',
    	flexDirection: 'column',
    	borderTop: '1px solid #AAA',	
    	borderRight: '1px solid #AAA',	
	},

	previewImg: {
		position: 'absolute',
		bottom: 0,
		right: 0,
		width: '40%',
		'filter': 'drop-shadow(0px 0px 1px rgba(0,0,0,0.3)) drop-shadow(0px 0px 10px rgba(0,0,0,0.3))',
	},

	fullscreenDiv: {
	    height: '100%',
	    display: 'flex',
	    alignItems: 'center', 
	    fontSize: '1.1em',
	    fontFamily: 'Roboto-Medium',
	},

	titleNotes: {
		color: COLOR.FLIPWIT_COLOR_1, 
		fontSize: '18px',
	    fontFamily: 'Roboto-Medium',
	    padding: 5,
    	height: 28,
    	width: '60%',
    	textAlign: 'center',
    	borderBottom: '1px solid ' + COLOR.FLIPWIT_COLOR_1,
    	marginBottom: 5,
	},

	divNotes: {
		display: 'flex',
    	flexDirection: 'column',
    	alignItems: 'center',
    	width: '100%',
	},

	divNotesText: {
		fontFamily: 'Roboto',
    	padding: 10,
    	textAlign: 'justify',
    	overflowY: 'auto',
    	lineHeight: '1.5em',
    	userSelect: 'none',
	},

	divForArrows: {
		display: 'flex',
    	alignItems: 'center',
    	justifyContent: 'center',
    	height: '100%',
    	visibility: 'hidden',
	},

	arrowNavButton: {
		width: "80%",
    	height: "80%",
    	backgroundColor: COLOR.FLIPWIT_COLOR_1,
    	color: 'white',
    	'&:hover': {
	      background: COLOR.FLIPWIT_COLOR_2
	    }
	},

	largeIcon: {
		width: 60,
    	height: 60,
	},

	fullScreenTools: {
		position: 'absolute',
		flex: 1,
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
		width: '100%',
		height: '10%',
		bottom: 0,
		left: 0,
		right:0,
		backgroundColor: 'black',
		opacity: 0.4,
		display: "flex",
	},

	paperHotPlugin: {
		backgroundColor: "red",
	},

	hotContainer: {
		position: "absolute",
    	width: "100%",
    	height: "100%",	
    	zIndex: "10",
	},

	connectionBar: {
		width: "100%",
	    display: "flex",
	    alignItems: "center",
	    justifyContent: "center",
	    overflow: "hidden",
	    textOverflow: "ellipsis",
	    /*whiteSpace: "nowrap",*/
					fontFamily: "Roboto-Medium",
					textAlign: 'center',
					padding: '5px',
	},

	subMenuIcon: {
	    color: COLOR.FLIPWIT_COLOR_1,
	    marginRight: '6px',
	},

	spanUserCount: {
	    display: "flex",
	    marginRight: "10px",
	    border: "solid 2px "+COLOR.FLIPWIT_COLOR_1,
	    padding: "0px 5px",
	    borderRadius: "8px",
	},

	fabFullScreen: {
		height: "30px",
	    width: "36px",
	    backgroundColor: COLOR.FLIPWIT_COLOR_1,
	    color: "white",
	    '&:hover': {
      		backgroundColor: COLOR.FLIPWIT_COLOR_2,
     	}  
	}
});

class PresentationMode extends FwScene {
	
	constructor(props) {
	  	super(props);
	  	this.buttonsFixed = false;
	  	this.pluginHandler = new PluginHandler();
	  	this.intervalCheckHeight = null;
	  	this.lastOrientation = null;

	  	this.strokeWidths = [1, 2, 5, 10, 20, 30];
	  	this.textToolSizes = [12, 24, 36, 48, 60, 72];

	  	this.shapeObject = LiterallyCanvas.createShape( 'Ellipse',
	  			{	
	  			 fillColor: "rgba(255,0,0,1)",
	  			 height: 10,
	  			 strokeColor: "rgba(255,0,0,1)",
	  			 strokeWidth: 5,
	  			 width: 10,
	  			 x: 10,
	  			 y: 10
	  			}
	  		);

	  	this._isMounted = true;

		this.currentPreview = "";

		this.tutorial = new FwTutorialClass();
	}

	state = {
		heightPreview: 0,
	    heightRightCont: 0,
	    showLoader: true,
	    showLoaderInHotPlugin: true,
	    initial: true,
	    showFSTools: false,
	    widthImg: 0,
	    heightImg: 0,
	    editionMode: false,
	    toolSelected: 1,
	    optionSelected: 1,
	    sizeSelected: 3,
	    currentTextSizeSelected:3,
	    pointerMode: false,
	    pointerX: 0,
	    pointerY: 0,
	    showToolPanel: 0, //0 -> No mostrar ningún panel, 1 -> Panel de seleccion de grosor, 2 -> Panel de selección de color, 3 -> Panel de selección de estilo de linea	    
	    blackboardMode: false,	 
	    fullscreenSupported: false,   
	    showHotPluginInView: null,
	}

	componentWillUnmount() {
		this._isMounted = false;
		clearInterval(this.intervalCheckHeight);
		console.log('this.manager', this.managerHammer)
		if( this.managerHammer ){
			this.managerHammer.off('swipe', this.onSwipe);
		}

	}

	initPresentationMode() {
		//TODO2 Quitar
		//platformHandler.createDummyData();

		platformHandler.reportCurrentExhibitorScreen("PresentationMode",{cloudPresentationID: platformHandler.cloudPresentationID,
																			isCloudPresentation: platformHandler.isCloud(),
	   																		pptName: platformHandler.getPPTName(),
	 																		configPPT: platformHandler.getConfigPPT() }, this.props.location.state==undefined?false:this.props.location.state.shouldReportCurrentScreenChange);
		platformHandler.checkTitleBarScene("PresentationMode");
	
		platformHandler.setListenerPresentation( this.dataSlide, null );	  	
		platformHandler.setListenerForData( this.dataPresentation );	 
		platformHandler.setListenerFullScreen( this.listenerFullScreen );
		platformHandler.setHotPluginListener(this.hotPluginListener, null);
		platformHandler.listenToAudienceQuestions(null);


		platformHandler.setUpdatePointer( this.updatePointer );

		platformHandler.setPresentationModeScreen( this );

	    //let { clientHeight, clientWidth } = ;
	    let node = ReactDOM.findDOMNode(this.imageCont);
	    console.log('encuentra node ' + node)
		if (node){
			this.nodeLeft = node;
		  	this.calculateHeightLeftNode();
		}

		node = ReactDOM.findDOMNode(this.rightCont);
		if (node){
		   let calculatedHeight = node.clientHeight;
		   this.setState( {heightRightCont: calculatedHeight });
		}
		
		//Inicia automaticamente la presentacion
		if( this.props.location.state.shouldReportCurrentScreenChange != false ){
	  		platformHandler.setIStartedPresentation(true);
	  	}

	  	this.onButtonPress( "Init" );

	  	var imagePrefetch = [];
  		setTimeout(function() {
			console.log('slidesData',JSON.stringify(platformHandler.slidesData))
  			for (let slide of platformHandler.slidesData) {
  				console.log('requesting ',slide.url,'de',slide)
  				const img = document.createElement('img');
      			img.src = slide.url; // Assigning the img src immediately requests the image
				//imagePrefetch.push(Image.prefetch(slide.url));
				imagePrefetch.push(img);
				//require(slide.url);
			}

			Promise.all(imagePrefetch).then(results => {
				
			});
  		}, 1000);

  		this.startLoader();

		console.log('Tiene Ref como ',document.getElementsByTagName("BODY")[0])

  		this.createHammer(document.getElementsByTagName("BODY")[0])  

		/*this.initDrawer();
  		this.dispatch(setPresentationModeConfig( "showDrawTools", true));
  		this.setState({ editionMode:true, pointerMode:false }) 
		this.toolSelected("pencil");	*/
	}

	createHammer(element) {
		console.log('Creando Hammer en ',element)
		// Create a manager to manager the element
		var manager = new Hammer.Manager( element );
		//La siguiente linea es si se quiere que se pueda hacer el zoom nativo del movil mientras se usa hammer
		//var manager = new Hammer.Manager( element, {touchAction : 'auto'} );
		
		// Create a recognizer
		var Swipe = new Hammer.Swipe();

		this.managerHammer = manager;

		// Add the recognizer to the manager
		manager.add(Swipe);
		//manager.add( new Hammer.Tap({ event: 'doubletap', taps: 2 }) );
		//manager.add( new Hammer.Tap({ event: 'singletap' }) );

		// we want to recognize this simulatenous, so a quadrupletap will be detected even while a tap has been recognized.
		//manager.get('doubletap').recognizeWith('singletap');
		// we only want to trigger a tap, when we don't have detected a doubletap
		//manager.get('singletap').requireFailure('doubletap');

		// Subscribe to desired event
		manager.on('swipe', this.onSwipe);
		//manager.on("singletap doubletap", this.onTap );
	}

	componentDidMount() {
		this.lastCall = 0;
		console.log('fullsupported ', platformHandler.isFullScreenSupported())
    	if( platformHandler.isFullScreenSupported()) {
    		this.setState({fullscreenSupported:true})    		
    	}

		setTimeout(this.initPresentationMode.bind(this), 1000);
		window.addEventListener("resize", this.updateDimensions);

		//console.log('Did mount con ',platformHandler.getUserConfig("tutorial_start_presentation_finished"),platformHandler.tutorial_start_second_part);
		console.log("El user config es",platformHandler.getUserConfig("tutorial_start_presentation_finished"));

		//Se coloca el false && para desactivar el tutorial
		if(false && !platformHandler.getUserConfig("tutorial_start_presentation_finished")) {

	      this.tutorial.setSteps([       
				{
					element: '#noexiste',
					intro: languageManager.getLangWord('INIT_TUTORIAL_STEP2'),
				},
				{
					element: '#fullScreenBut',
					intro: languageManager.getLangWord('INIT_TUTORIAL_STEP3'),
				},
				{
					element: '#noexiste',
					intro: languageManager.getLangWord('INIT_TUTORIAL_STEP4'),
				},
				{
	            	element: '#buttonNextCont',
	            	intro: languageManager.getLangWord('INIT_TUTORIAL_STEP5'),
	          	},
	          	{
	            	element: '#subMenuBot',
	            	intro: languageManager.getLangWord('INIT_TUTORIAL_STEP6'),
	          	}
	          	]
	      	);

			//Si es la primera parte del tutorial, la que sale en el computador entonces
			//la ejecuta, si no todo se inicia en la funcion de listenerFullScreen
			if(platformHandler.tutorial_start_second_part!==true){
	      		this.tutorial.setShowTutorial(true);
	      		this.tutorial.colocarEstadoTutorial(0);   
			}
			else {
				this.tutorial.setShowTutorial(true);
      			this.tutorial.colocarEstadoTutorial(2);  			
			}
	    }
	}

	cambiarPasoTutorial = (newStep) => {
		this.tutorial.colocarEstadoTutorial(newStep);
	}

	finishStartTutorial = () => {
		console.log('Que con ',this.tutorial.getShowTutorial());
		if(this.tutorial.getShowTutorial()) {
			console.log('Lo quita supuestamente');
			this.tutorial.setShowTutorial(false);
			this.forceUpdate();
			platformHandler.setUserConfig("tutorial_start_presentation_finished",true);			
		}
	}

	updateDimensions = () => {
		console.log('resize',this.state, platformHandler.isFullScreen())

		if(this.mainDiv===null || this.mainDiv===undefined) {
			window.removeEventListener("resize", this.updateDimensions);
			return;
		}

		this.mainDiv.style.height = (window.innerHeight - 64) + 'px'

		this.buttonsFixed = false;
		if(this.state.toolSelected!=2) { 
			this.initDrawer();		
			this.forceUpdate();
		}
    }

	activateTool = ( value ) =>{
		var elementToMatch = document.getElementById("divDrawer");

		if( value ){
			//elementToMatch.style.pointerEvents = "auto";
		}
		else{
			elementToMatch.style.pointerEvents = "none";
		}
	}

	initDrawer = ( disableTool = false ) =>{
		var elementToMatch = document.getElementById("divDrawer");
		if( elementToMatch == null ) return;

		//TODO: El scroll en la pantalla de dibujo estaba causando un bug
		//y se hizo este parche machetudo para arreglarlo
		if(document.getElementById("dialogTools")!==null) {
			document.getElementById("dialogTools").children[1].style.overflowY = "scroll"			
		}
		
		console.log('ANTES: ',elementToMatch.offsetHeight)
		console.log('>>>>>>>>>>>>>lo inicia con ', elementToMatch, null, this.state.widthImg, this.state.heightImg, elementToMatch.offsetHeight ,elementToMatch.offsetWidth,document.getElementById("hiddenImg").width)

		let fnFixWH = () => {

			try {
				if(document.getElementById("canvasBack")===null || document.getElementById("canvasBack")===undefined) {
					setTimeout(fnFixWH,200);
					return;
				}

				console.log('Nuevo width',this.state.widthImg, this.state.heightImg, elementToMatch.offsetHeight ,elementToMatch.offsetWidth,document.getElementById("hiddenImg").width);				
				let w = document.getElementById("hiddenImg").width;
				let h = document.getElementById("hiddenImg").height;

				let fixWH = (str) => {				
					let objToFix = document.getElementById(str);
					objToFix.width = w;
					objToFix.style.width = w+"px";
					objToFix.height = h;
					objToFix.style.height = h+"px";
				}
							
				fixWH("canvasBack");
				fixWH("canvasFront");

				this.lc.repaintAllLayers();
				this.createLC();
			}
			catch(ex) {

			}
		}

		setTimeout(fnFixWH,200);

		this.createLC();
	}

	createLC = ( disableTool ) => {		

		var elementToMatch = document.getElementById("divDrawer");
		if( elementToMatch == null ) return;

		this.lc = LiterallyCanvas.init(elementToMatch, null, this.state.widthImg, this.state.heightImg);
		this.lc.respondToSizeChange();
		console.log('DESPUES: ',elementToMatch.offsetHeight)

		this.lineTool = new LiterallyCanvas.tools.Line( this.lc);
		this.textTool = new LiterallyCanvas.tools.Text( this.lc);

		var scope = this;
		this.lc.setColor("secondary","rgba(255,255,255,0)",disableTool);
		platformHandler.setDrawingCanvas( this.lc, this.initDrawer );
		this.lc.loadSnapshot(platformHandler.getCurrentSlideDrawing())
		
		if( disableTool ){
			console.log('disableTool')
			console.trace();
			this.setState({ editionMode:false, pointerMode:false }) 
			this.lc.setTool( new LiterallyCanvas.tools.Eyedropper());
		}
		else{
			if( this.state.editionMode ){
				if( this.lastTool ){
					this.toolSelected( this.lastTool );
					if( this.lastColor ){
						console.log('set color ' + this.lastColor)
						this.lc.setColor("primary",this.lastColor);
					}
				} 
			}
			else{
				this.lc.setTool( new LiterallyCanvas.tools.Eyedropper());
			}
		}
		
		console.log('------> pone eventos')
		
		//this.activateTool(false);
		this.lc.on('shapeSave', function(e) {
			//console.log('shape',  e.shape.className, e.shape.toJSON(), e.shape.id )
		  platformHandler.addShapeDrawing( e.shape.className, e.shape.toJSON(), e.shape.id );

		});

		this.lc.on('drawContinue', function( event ) {
			//console.log('eventContinue ',event,scope.state.editionMode)
			if(scope.state.pointerMode){
				scope.shapeObject.x = event.x - 5;
				scope.shapeObject.y = event.y - 5;
				scope.lc.drawShapeInProgress( scope.shapeObject );

				platformHandler.pointerChange( true, scope.shapeObject.x, scope.shapeObject.y );
			}
			
		});

		this.lc.on('drawStart', function( event ) {
			//console.log('start Event',scope,event)
			if(scope.state.pointerMode){
				scope.shapeObject.x = event.x - 5;
				scope.shapeObject.y = event.y - 5;
				scope.lc.drawShapeInProgress( scope.shapeObject );

				platformHandler.pointerChange( true, scope.shapeObject.x, scope.shapeObject.y );
			}
		});

		this.lc.on('drawEnd', function( event ) {
			//console.log('drawEnd ',event)
			if(scope.state.pointerMode){
				platformHandler.pointerChange( false, event.x, event.y );
			  	scope.lc.repaintLayer('main', false);
			}
		});

		//TODO: El scroll en la pantalla de dibujo estaba causando un bug
		//y se hizo este parche machetudo para arreglarlo
		if(document.getElementById("dialogTools")!==null) {
			document.getElementById("dialogTools").children[1].style.overflowY = ""			
		}		
	}

	updatePointer = ( visible, data ) =>{		
		if( visible ){
			if( data ){
				const pointsArray = Object.values(data);
				if( pointsArray.length > 0 ){
					const point = pointsArray[ pointsArray.length - 1];
					this.shapeObject.x = point.x;
					this.shapeObject.y = point.y;
					this.lc.drawShapeInProgress( this.shapeObject );
				}				
			}			
		}	
		else{
			if( this.lc ){
				this.lc.repaintLayer('main', false);
			}
		}	
	}

	tryShowFSTools = () => {
		if( platformHandler.isFullScreen() ) {
			if(!this.state.showFSTools)
			{
				this.setState( {showFSTools: true });		
				this.timeoutTools = setTimeout( this.hideFSTools,3000);		
			}
			else {
				clearTimeout( this.timeoutTools );
				this.timeoutTools = setTimeout( this.hideFSTools,3000);			
			}
		}
	}

	hideFSTools = () =>{
		this.setState( {showFSTools: false });
	}

	//Esto no se esta usando ya que el tap en fullscreen debe es pasar de diapositiva
	onTap = (e) =>{
		if( platformHandler.isFullScreen() ){
			switch(e.type){
				case "singletap": 
								  clearTimeout( this.timeoutTools );
								  this.setState( {showFSTools: true });
								  this.timeoutTools = setTimeout( this.hideFSTools,5000);
					break;

				case "doubletap": 	console.log('Toggle con doubleTap')
									platformHandler.toggleFullScreen( );
					break;
			}
		}
	}

	onSwipe = (e) =>{
		if ( this.state.editionMode || this.state.pointerMode || this.tutorial.getShowTutorial()){
			return false;
		}

		console.log('Detecta el swipe en e.offsetDirection',e.offsetDirection,e)
		if (new Date() - this.lastCall < 1000)
		    return false;
		       
		console.log('continue swipe') 
		this.lastCall = new Date();

		//if( platformHandler.isFullScreen() && !this.state.editionMode ){
			var direction = e.offsetDirection;
			if ( direction === 4 ) {
				platformHandler.actionInPresentation("Prev");
			}
			else if( direction === 2 ){
				platformHandler.actionInPresentation("Next");
			}
			/*else if( direction === 16 ){
				platformHandler.toggleFullScreen( );
			}*/
		//}
	}

	//El proposito original de esta función era poder desde el celular poner fullscreen la vista del 
	//computador, es decir, enviar un comando de volverse fullscreen remotamente, no obstante, esto no esta funcionando
	//ya que el comando de fullscreen debe venir de un click del usuario, 
	//pero entonces esto se esta usando para poder continuar con el tutorial, ya que una parte depende de que se 
	//haya colocado en fullscreen la pantalla
	listenerFullScreen = () => {
		console.log('Ejecuta listener de full',platformHandler.getUserConfig("tutorial_start_presentation_finished"),platformHandler.tutorial_start_second_part);
		if(!platformHandler.getUserConfig("tutorial_start_presentation_finished") && platformHandler.tutorial_start_second_part) {
			console.log('Pone el turtorial supuestamente');			
	      this.tutorial.setShowTutorial(true);
	      this.tutorial.colocarEstadoTutorial(3);  
	      this.forceUpdate(); 
	    }

		//this.setFullScreen( false );
	}

	calculateHeightLeftNode = () => {
		/*let calculatedHeight = this.nodeLeft.clientHeight;

		if( calculatedHeight != this.state.heightPreview){
			//this.hideCanvasDrawing();
			this.date = new Date().getTime();
			this.setState( {heightPreview: calculatedHeight });
			this.nodeLeft.style.width = "100%";

			this.initDrawer( false );
			console.log('hubo un cambio: ' + this.state.heightPreview)
			clearInterval(this.intervalCheckHeight);
		}*/

		//console.log('height of that ' + calculatedHeight)
	}

	hotPluginListener = (data) => {

		let hasPlugin = data.activated;

		if(hasPlugin) {
			this.setState({showHotPluginInView:data});			
		}
		else {
			this.setState({showHotPluginInView:null});						
		}

		//console.log('Llega una informacion de hotplugin',data,hasPlugin)
		//this.props.dispatch(setPresentationModeConfig( "showHotPlugin", hasPlugin));
		/*if(data!=={}) {

		}*/
	}

	dataSlide = (success,data) => {

		if( data ){
			
			//Si es la informacion estatica, esta es por ejemplo la cantidad de diapositivas
			//ese numero no cambia en medio de la presentacion
			if(data.isStaticInfo==true) {}
			else {

				if( this._isMounted && data.communData ){
					if( data.communData.previewUrl != this.currentPreview ){
						this.startLoader();	
					}
				}
			}

			/*if( this.webViewer ){
				this.webViewer.forceUpdate()
			}

			if( this.webExhibitor ){
				this.webExhibitor.forceUpdate()
			}*/
		}
	}

	startLoader(){
		console.log('loaderrr inicia')
		this.date = new Date().getTime();
		this.setState({ showLoader:true }) 
	}

	dataPresentation = (data) => {
		if( data ){
			console.log('dataPresentation: ' + JSON.stringify(data) );
			switch(data.command) {
				case "changePreview": 	if(data.preview != ""){
											this.dispatch(setSlidePreview( data.preview ));
										} 
										break;

				case "finish": 	if( platformHandler.isLAN ){
									platformHandler.cleanLanSession();
									platformHandler.openScene( "SelectPresentation" );
								}else{
									platformHandler.openScene( "MainMenu" );
								}
								 
								break;					
			}
			
			//this.dispatch(setSlideInfo( data.url, data.slideIndex, data.idToglea, data.titleToglea, data.infoToglea ));
		}
	}

	onButtonPress = (action, showLoader = false) => {
		platformHandler.actionInPresentation(action);

		if(!platformHandler.getUserConfig("tutorial_start_presentation_finished") && platformHandler.tutorial_start_second_part && action==="Next") {
			//tutorial.setShowTutorial(true);	      			
			this.tutorial.colocarEstadoTutorial(4);  
		    this.forceUpdate(); 		    
		}

		//Apaga los botones de dibujar y laser porque no siempre se pueden usar, solo si cuando llegue la siguiente
		//diapositiva esta es de tipo imagen
		this.props.dispatch(setPresentationModeConfig( "showMenuTools", false));

		if( showLoader ){
			console.log('PONE EL LOADER');
			this.startLoader();
			//this.setState({ showLoader:true }) 
		}
	};

	getLinesForPlatform = () => (10);//getValuePlatform(26, 6,6,6));

	handleImageErrored = (e) => {
	    console.log('failed to load ' + e.message);
	 }

	getImageComp(currentData){
		
		const { classes,configPresentationMode } = this.props;		

		this.currentPreview = currentData.previewUrl;
		console.log('the image is: ' + currentData.previewUrl)
		
		/*
		Si se coloca esto en true, se usa la barra de ayuda, no se deja siempre ya que no se ha
		terminado de desarrollar
		 */
		var usarBarra = configPresentationMode.showUrlBar;
		//usarBarra = false;

		var mostrarBarraAyuda = true;
		var altoBarraAyuda = 60;
		var fontBarraAyuda = 25;
		var maxWidthBarra = document.documentElement.offsetWidth;
		var mensajeBarra = this.props.shareFinish?<span>
							Para conectarte y recibir esta presentación ingresa a <span style={{color:'#FF5722',marginLeft:fontBarraAyuda/3}}> www.fwtap.com/{platformHandler.getUrlForUser()}</span>
						</span>:
						<span>
							Para conectarte a esta presentación ingresa a	<span style={{color:'#FF5722',marginLeft:fontBarraAyuda/3}}> www.fwtap.com/{platformHandler.getUrlForUser()}</span>
						</span>;
		
		if(!platformHandler.isFullScreen()) {
			
			let landscapeOrientation = this.getOrientation()=="landscape";

			if(landscapeOrientation) {
				altoBarraAyuda = 50;
				maxWidthBarra=maxWidthBarra/2;
			}
			else {
				altoBarraAyuda = 20;				
			}			
			
			fontBarraAyuda = document.documentElement.offsetHeight/40;	
		}

		//Si esta en el panel de dibujo o en el panel de puntero no muestra la barra y la imagen
		//se toma todo el espacio
		if(configPresentationMode.showDrawTools || configPresentationMode.showLaserPointer) {
			mostrarBarraAyuda = false;
		}

		//En este objeto se define el alto de la imagen según tenga o no barra de ayuda
		var styleDivImg = {height: 'calc( 100% - '+altoBarraAyuda+'px )'};
		

		if(!mostrarBarraAyuda) {			
			styleDivImg = {height: '100%'};
		}

		console.log('LLEGA AL CALCULO CON ' +  !mostrarBarraAyuda + '||' +  !usarBarra + " = ", (usarBarra?styleDivImg:{height: '100%'}));

		return (
			<React.Fragment>
				{(mostrarBarraAyuda && usarBarra) && <div id="connectionBar" className={classes.connectionBar} style={{minHeight: altoBarraAyuda,fontSize:fontBarraAyuda,maxWidth:maxWidthBarra}}>
					{this.props.usersCount>0 && <span className={classes.spanUserCount}>
						<GroupIcon className={classes.subMenuIcon} /> {this.props.usersCount}
					</span>}
					{mensajeBarra}
				</div>}
				<div id="imgContainer" className={classes.imgContainer} style={usarBarra?styleDivImg:{height: '100%'}} onClick={() => {/*if(platformHandler.isFullScreen()) this.onButtonPress("Next", true)*/}}>
					<CardMedia
						id="imgPresentationMode"
			        	className={classes.media}
			        	image={currentData.previewUrl}
			        	//onLoad={this.onImageLoaded}
			        >
						<img id="hiddenImg" className={classes.hiddenImg} src={currentData.previewUrl} onLoad={this.onImageLoaded} />
			        	<div id="divDrawer" className={classes.drawer}></div>
			        	{this.paintPreviewNext(currentData)}
			        </CardMedia>
				</div>
			</React.Fragment>
		);
	}

	onImageLoaded = (e) => {

		if(e==undefined) return;
		console.DEBUG_FLIPWIT('CARGOOOOOOOOOOOOOOOOOO ' + this.props.currentData.previewUrl,e.nativeEvent.srcElement.width,e.nativeEvent.srcElement.height,e.nativeEvent.srcElement,e.nativeEvent.srcElement.naturalWidth)
		
		//this.setState( {heightPreview: e.nativeEvent.srcElement.height });

		if( this.props.currentData.previewUrl.indexOf("images/nopreview.png") == -1){
			this.setState({ showLoader:false }) 
			if( this.state.initial ){
				this.setState({ initial:false }) 
			}			
			
			//compruebe solo si no es el preview y no es una actividad de toglea
			if( this.props.currentData.idToglea == ""){
				//Prende los botones de dibujar y laser ya que la diapositiva es de imagen
				this.props.dispatch(setPresentationModeConfig( "showMenuTools", true));

				try{
					if( e.nativeEvent.srcElement ){
						//this.setState({ widthImg:100, heightImg: 100 },() => {
						this.setState({ widthImg:e.nativeEvent.srcElement.naturalWidth, heightImg: e.nativeEvent.srcElement.naturalHeight },() => {
						//this.setState({ widthImg:e.nativeEvent.srcElement.width, heightImg: e.nativeEvent.srcElement.height },() => {
							console.log('>>>>>>>>>>>>SETEA ESTADO WID2 ', this.state.widthImg,this,this.state)
							this.initDrawer();
							
						}) 
						console.log('>>>>>>>>>>>>SETEA ESTADO WID ', e.nativeEvent.srcElement.width, this.state.widthImg,this,this.state)
					}
					else{
						this.setState({ widthImg:e.nativeEvent.path[0].width, heightImg: e.nativeEvent.path[0].height }) 
					}
				}
				catch(e){
					console.log('ERROR getting width n height', e)
				}
				
				//setTimeout( this.checkImage,200);				
			}
		}	
		else {
			this.setState({ heightPreview: e.nativeEvent.srcElement.height })
		}
	}


	checkImage = () => {
		/*let nodeImage = ReactDOM.findDOMNode(this.imageComp);

		if (nodeImage){
			let backTemp = nodeImage.style.backgroundImage;
			console.log('COMPARA')
			if( backTemp == undefined || backTemp == "" ){
				console.log('NO HAYYYYYYYYY')
				nodeImage.style.backgroundImage = "url(" + this.props.currentData.previewUrl + ")"
			}
			else if( this.state.showLoader){
				this.setState({ showLoader:false }) 
			}
		}*/
	}

	getNotesComp(currentData){
		const { classes } = this.props;		

		return (
			<React.Fragment>
				<div className={classes.titleNotes}>{languageManager.getLangWord("NOTES")}</div>
				<div className={classes.divNotesText}>
					<a>
						{currentData.noteSlide}						
					</a>
				</div>
			</React.Fragment>
		);			
	}

	onReceiveMessageForHotPluginHere(msg){
		if(msg==undefined) return;
		console.log('recibio for webHotPlugin: ', msg,this.webHotPlugin)
		let jsonMsg = JSON.parse( msg );
		
		this.pluginHandler.messageFromWebPlugin( jsonMsg, this.webHotPlugin, this.props.currentData, true);
	}

	onReceiveMessageForHotPluginViewer(msg){
		if(msg==undefined) return;
		console.log('recibio for webHotPluginViewer: ', msg,this.webHotPluginViewer)
		let jsonMsg = JSON.parse( msg );
		
		this.pluginHandler.messageFromWebPlugin( jsonMsg, this.webHotPluginViewer, this.props.currentData, true);
	}

	onReceiveMessage(msg){
		if(msg==undefined) return;
		console.log('recibio for webViewer: ', msg,this.webViewer)
		let jsonMsg = JSON.parse( msg );
		
		this.pluginHandler.messageFromWebPlugin( jsonMsg, this.webViewer, this.props.currentData, true);
	}

	onExhibitorMessage(msg){
		if(msg==undefined) return;
		console.log('recibio exhibitor: ', msg)

		if(msg.source==="@devtools-page") return;

		//if( msg.source == "exhibitor" ){
			let jsonMsg = JSON.parse( msg );
		    
		    this.pluginHandler.messageFromWebPlugin( jsonMsg, this.webExhibitor, this.props.currentData, true);
		//}	    
	}

	getWebViewerComp(currentData){
		var isElectronExhibitor = (platformHandler.isElectron && !platformHandler.isCloud() );
		
		console.log('isElectronExhibitor ' + isElectronExhibitor,currentData)

		var paramOptional = "";
		if( isElectronExhibitor ){
			paramOptional = "electron=true&";
		}

		paramOptional += "presMode=true&";

		let urlActivity = currentData.urlActivity;

		//TODO2
		urlActivity = currentData.urlActivity.replace("plugins", "pluginsTest");
		
		/*if(urlActivity.indexOf("wordcloud")!==-1) {
				urlActivity = "http://192.168.1.53:3001/?";
			}*/

		var urlFinalViewerMinimizado = urlActivity + '/viewer/?'+ paramOptional + this.date;

		if(webViewsPrueba.urlFinalViewerMinimizado!==undefined) {
			urlFinalViewerMinimizado = webViewsPrueba.urlFinalViewerMinimizado;
		}

		//urlFinalViewerMinimizado = "http://192.168.1.53:3002/"


		//Abajo esta lo del estilo en height 100% porque no se ha terminado lo de la barra, realmente luego hay que hacer un 
		//componente o algo que defina si se pone la barra ya que hasta el momento solo esta presente en una imagen de preview y 
		//no en un plugin

		return (
			<div id="imgContainer" className={this.props.classes.imgContainer} style={{height:'100%'}}>
				<WebViewFW ref={(child) => { this.webViewer = child; }}
					name={"webViewer"}
				    urlWebView={urlFinalViewerMinimizado  }
				    //urlWebView={ "http://localhost:3001/?" + paramOptional + this.date }
				    //urlWebView={ "http://192.168.1.53:3001/?" + paramOptional + this.date }
				    //urlWebView={ "http://192.168.1.53/flipwit_plugins/static/survey/viewer/?" + this.date }
				    //pointerEvents={"none"}
				    style={{backgroundColor: 'white',minHeight: this.state.heightPreview,width:'100%'}}
				    height={'100%'}
				    idToglea={ currentData.idToglea }
				    handleReady={() => {this.setState({showLoader:false})}}
				    handleReceiveMessage={this.onReceiveMessage.bind(this)}
				    onClick={() => {if(platformHandler.isFullScreen()) this.onButtonPress("Next", true)}}
			  	/>
			  	{this.paintPreviewNext(currentData)}
			</div>
		);
	}

	checkHammerOnIframe() {
		//TODO colocarle el hammer al body dentro del iframe que debe ser pasado por la api
		//console.log('Hammer en ', document.getElementById("iframeExhibitor").contentWindow.document)
		//this.createHammer(document.getElementById("iframeExhibitor"));
	}

	getWebExhibitorComp(currentData){

		let urlActivity = currentData.urlActivity;

		//TODO2
		urlActivity = currentData.urlActivity.replace("plugins", "pluginsTest");

		var urlFinalExhibitor = urlActivity + '/exhibitor/?' + this.date;

		//urlFinalExhibitor = "http://192.168.1.53:3003/";

		return (
			<WebViewFW ref={(child) => { this.webExhibitor = child; }}
			name={"webExhibitor"}
			id="iframeExhibitor"
			urlWebView={urlFinalExhibitor }		    
			//urlWebView={ "http://localhost:3001/?" + this.date }
			//TODO2
			//urlWebView={ "http://192.168.1.53/flipwit_plugins/static/survey/exhibitor/?" + this.date }
		    height={'100%'}
		    handleReceiveMessage={this.onExhibitorMessage.bind(this)}
		    handleReady={() => {this.setState({showLoader:false});
		    					this.checkHammerOnIframe.bind(this)}}
		  />);
	}

	stopDrawing = () =>{
		console.log('stop editionMode')
		console.trace();
		this.setState({ editionMode:false }) 
		this.lc.setTool( new LiterallyCanvas.tools.Eyedropper());
	}

	startPointer = () =>{
		if( this.state.pointerMode ){
			this.setState({ pointerMode:false }) 
		}
		else{
			if( this.state.editionMode ){
				this.stopDrawing();
			}
			
			this.setState({ pointerMode:true }) 
			this.activateTool(true);
		}		
	}

	hideCanvasDrawing = () => {
		try{
			if( this.lc ){
				this.lc.canvas.style.display = "none";
			}
		}
		catch(e){}
	}

	setFullScreen = ( sendCommand = true ) => {
		
		if(this.tutorial.getShowTutorial()) {
			this.tutorial.setShowTutorial(false);
		}

		this.hideCanvasDrawing();
		
		console.log('Toggle con elemento ',sendCommand)
		//platformHandler.toggleFullScreen( ReactDOM.findDOMNode(this.slideContainerNode), sendCommand );
		platformHandler.toggleFullScreen( document.getElementById("slideContainer"), sendCommand );
		//this.initDrawer();
		setTimeout(() => {console.log("LLAMA TIMER 200",platformHandler.isFullScreen()); this.forceUpdate()},500);			
		//();

		/*if( this.intervalCheckHeight == null ){
			this.intervalCheckHeight = setInterval( this.calculateHeightLeftNode, 500);
		}*/

	}



	paintFullScreenTools = ( currentData ) =>{
		if( ! platformHandler.isFullScreen() ){
			return null;
		}


		if( !this.state.showFSTools ){
			return null;
		}

		/*<View style={styles.toolsFS}>
			<IconToggle name="&#xE5D1;" onPress={() => this.setFullScreen()} 
			    			style={ stylesCarbon.iconos } 
			    			iconStyle={ { color:themes.light.colors.primary, fontSize: TEXT_SIZES.CLOCK}} />;
		</View>*/

		return(
			<div className={this.props.classes.fullScreenTools}>
				<IconButton
	              color="inherit"
	              onClick={() => this.setFullScreen()}                
	              className={this.props.classes.menuButton}	     
	              //classes={{label:this.props.classes.iconMenuBar}} 
	              style={{margin: "8px",marginRight: "4%"}}        
	            >
	              <FullscreenExitIcon style={{width: '100%',height: '100%'}}/>
	            </IconButton>
			</div>
		);
	}

	paintPreviewNext( currentData ){
		
		const { configPresentationMode, classes } = this.props;

		if(!configPresentationMode.showPreview) {
			return null;
		}
			
		console.log('Pintar next? porque fullscreen es', platformHandler.isFullScreen())
		if( platformHandler.isFullScreen() || configPresentationMode.showDrawTools || configPresentationMode.showLaserPointer){
			return null;
		}

		if( currentData.previewUrl.indexOf( "nopreview.png" ) != -1 ){
			return null;
		}

		if ( currentData.indexSlide < currentData.totalSlides 
			&& currentData.indexSlide > 0 ){

			let nextImg = "";
			if( platformHandler.isLAN && ! platformHandler.isElectron){
				nextImg = platformHandler.nextPreviewLan;
			}
			else{
				if( platformHandler.slidesData[currentData.indexSlide] ){
					let nextIndex = parseInt(currentData.indexSlide) + 1;
					//let nextImg = currentData.previewUrl.replace("%2F" + currentData.indexSlide + ".jpg", "%2F"+ nextIndex +".jpg");
					nextImg = platformHandler.slidesData[currentData.indexSlide].url;	
				}
			}
			
			try{
				if(document.getElementById("previewImg").src!=nextImg) {
					document.getElementById("previewImg").style.visibility = "hidden";					
				}
			}
			catch(e){}

			return(
				<img id="previewImg" className={classes.previewImg} src={nextImg} onLoad={() => {document.getElementById("previewImg").style.visibility = "visible"}}/>				
			);
		}
		else{
			return null;
		}
		
	}

	textSizeSelected = ( size ) =>{
		this.textTool.font = "bold " + this.textToolSizes[size-1] + "px sans-serif";		
		this.setState({currentTextSizeSelected: size, showToolPanel:0})		
	}

	sizeSelected = ( size ) =>{
		this.lc.tool.strokeWidth = this.strokeWidths[size-1];
		this.setState({sizeSelected: size, showToolPanel:0})		
	}

	toolSelected = ( tool ) =>{
		let toolNumber = this.state.toolSelected;
		
		switch( tool ){			
			case "pencil": 	toolNumber = 1;
							this.lastTool = tool;
							this.lc.setTool( new LiterallyCanvas.tools.Pencil( this.lc));break;

			case "text": 	toolNumber = 2;
							this.lastTool = tool;
							this.lc.setTool( this.textTool );break;

			case "line": 	toolNumber = 3;
							this.lastTool = tool;
							this.lc.setTool( this.lineTool );break;

			case "square": 	toolNumber = 4;
							this.lastTool = tool;
							this.lc.setTool( new LiterallyCanvas.tools.Rectangle( this.lc));break;

			case "ellipse": toolNumber = 5;
							this.lastTool = tool;
							this.lc.setTool( new LiterallyCanvas.tools.Ellipse( this.lc));break;

			case "eraser": 	toolNumber = 6;
							this.lastTool = tool;
							this.lc.setTool( new LiterallyCanvas.tools.Eraser( this.lc));break;

			case "undo":this.lc.undo(); 
						platformHandler.actionInDrawing("undo");
						platformHandler.drawingChange( this.lc.getSnapshot(['shapes', 'colors'])); 
						break; 

			case "redo":this.lc.redo(); 
						platformHandler.drawingChange( this.lc.getSnapshot(['shapes', 'colors'])); 
						platformHandler.actionInDrawing("redo");
						break;

			case "clear":this.lc.clear(); 
						platformHandler.drawingChange( this.lc.getSnapshot(['shapes', 'colors']));
						platformHandler.actionInDrawing("clear");
						break;

			case "dash": this.lineTool.isDashed = !this.lineTool.isDashed; break;

			case "arrow":this.lineTool.hasEndArrow = !this.lineTool.hasEndArrow; break;

			case "bgOn":this.lc.setColor("background", "rgba(255,255,255,255)");
						this.setState({blackboardMode:true})
						platformHandler.drawingChange( this.lc.getSnapshot(['shapes', 'colors'])); 
				break;

			case "bgOff":this.lc.setColor("background","transparent"); 
						this.setState({blackboardMode:false})
						platformHandler.drawingChange( this.lc.getSnapshot(['shapes', 'colors']));
				break;

		}

		this.lc.tool.strokeWidth = this.strokeWidths[this.state.sizeSelected-1];
		this.textSizeSelected( this.state.currentTextSizeSelected );		

		if( this.state.toolSelected == 3 && toolNumber != 3 ){
			if( this.state.optionSelected == 3 ){
				this.setState({ optionSelected: 1 });
			}
		}
		this.setState({ toolSelected: toolNumber });
		
	}

	getEditionTools( currentData ){
		let componentToShow = null;
		var paddingValue = platformHandler.isMobile ? 4 : 10;
		
		return (
			{/*<View style={{ height:'100%', display: '-webkit-box', padding: paddingValue,}}>
				{ this.getBlackboardComp(currentData)}
				{ this.getToolsComp(currentData)}
				{ this.getOptionsComp(currentData)}
						
			</View>*/}
		);
	}

	getColorComp( ){
		//colors={['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E']}
		//<CirclePicker onChange={ this.handleChangeColor } />
		return (<div style={{margin: 8}}>
					<FW_ColorPicker onChange={ this.handleChangeColor } />					
				</div>);
	}

	getStyleComp(){

		const { classes } = this.props;

		let selectedStyle = {
			'filter': 'drop-shadow(0px 0px 1px rgba(0,0,0,0.3)) drop-shadow(0px 0px 10px rgba(0,0,0,0.3))',
			'backgroundColor': '#BBB',
		}

		return (
			<React.Fragment>
				<Button id={"style1"} variant="outlined" onClick={() => this.toolSelected("dash")} className={classes.toolIconButtonOption} style={ (this.lineTool.isDashed)?selectedStyle:{} }>
		        	{this.getSVGLine(false,true)}				        				        	
		        </Button>
		        <Button id={"style2"} variant="outlined" onClick={() => this.toolSelected("arrow")} className={classes.toolIconButtonOption} style={ (this.lineTool.hasEndArrow)?selectedStyle:{} }>
		        	{this.getSVGLine(true,false)}
		        </Button>
			</React.Fragment>
		);
		/*var selectedStyle = {...stylesCarbon.baseIcon, ...{backgroundColor:'#D2D2D2'}}

		return ( 
			{/*<View style={styles.toolsEdition}>
				<TouchableRipple rippleCentered rippleSpread={0.34} style={this.lineTool.isDashed?selectedStyle:stylesCarbon.baseIcon} onPress={() => this.toolSelected("dash")}>
			       <Image source={require('../assets/buttons/dotted.png')} style={{  width: 24, height: 24}} />
			    </TouchableRipple> 

		    	<TouchableRipple rippleCentered rippleSpread={0.34} style={this.lineTool.hasEndArrow?selectedStyle:stylesCarbon.baseIcon} onPress={() => this.toolSelected("arrow")}>
		           <Image source={require('../assets/buttons/arrow.png')} style={{  width: 24, height: 24}} />
		        </TouchableRipple> 
			</View>}
		);*/
	}

	optionSelected( option ){
		this.setState({optionSelected: option});
	}

	getOptionsComp( currentData ){
		let styleFlat = {margin:0,padding:2,paddingLeft:4, paddingRight:4, borderWidth: 0.5,borderColor: 10,};
		let styleSelected = {...styleFlat, ...{backgroundColor:'#D2D2D2'}};
		let option = this.state.optionSelected;
		return (
			{/*<View style={styles.toolsView}>
				<View style={styles.toolsEdition}>
					<FlatButton css={(option==1)?styleSelected:styleFlat} onPress={() => this.optionSelected(1)}>{languageManager.getLangWord("THICKNESS")}</FlatButton>
					<FlatButton css={(option==2)?styleSelected:styleFlat} onPress={() => this.optionSelected(2)}>{languageManager.getLangWord("COLOR")}</FlatButton>
					{ 	this.state.toolSelected == 3 &&
						<FlatButton css={(option==3)?styleSelected:styleFlat} onPress={() => this.optionSelected(3)}>{languageManager.getLangWord("STYLES")}</FlatButton>
					}
				</View>
				{ option == 1 && this.getSizesButtons()}
				{ option == 2 && this.getColorComp()}
				{ option == 3 && this.getStyleComp()}
			</View>*/}
		);
	}

	getToolsComp( currentData ){
		//var selectedStyle = {...stylesCarbon.baseIcon, ...{backgroundColor:'#D2D2D2'}}
		//var selectedStyle2 = {...stylesCarbon.iconosEdition, ...{backgroundColor:'#D2D2D2'}}
		let tool = this.state.toolSelected;

		return (
			{/*<View style={styles.toolsView}>
				<Text style={styles.textEdition}>{languageManager.getLangWord("TOOLS")}</Text>
				<View style={styles.toolsEdition}>
					<IconToggle name="&#xE3AE;" onPress={() => this.toolSelected("pencil")} 
					    			style={ (tool==1)?selectedStyle2:stylesCarbon.iconosEdition } 
					    			iconStyle={ {  fontSize: TEXT_SIZES.CLOCK}} />

					<TouchableRipple rippleCentered rippleSpread={0.34} style={(tool==2)?selectedStyle:stylesCarbon.baseIcon} onPress={() => this.toolSelected("eraser")}>
				       <Image source={require('../assets/buttons/eraser.png')} style={{  width: 24, height: 24}} />
				    </TouchableRipple>    		

					<TouchableRipple rippleCentered rippleSpread={0.34} style={(tool==3)?selectedStyle:stylesCarbon.baseIcon} onPress={() => this.toolSelected("line")}>
				       <Image source={require('../assets/buttons/line.png')} style={{  width: 24, height: 24}} />
				    </TouchableRipple> 

					<IconToggle name="&#xE3C1;" onPress={() => this.toolSelected("square")} 
					    			style={ (tool==4)?selectedStyle2:stylesCarbon.iconosEdition } 
					    			iconStyle={ { fontSize: TEXT_SIZES.CLOCK}} />

			    	<IconToggle name="&#xE40C;" onPress={() => this.toolSelected("ellipse")} 
			    	    			style={ {...((tool==5)?selectedStyle2:stylesCarbon.iconosEdition), ...{marginRight: 10}} } 
			    	    			iconStyle={ { fontSize: TEXT_SIZES.CLOCK}} />

    		    	<IconToggle name="&#xE166;" onPress={() => this.toolSelected("undo")} 
    		    	    			style={ stylesCarbon.iconosEdition } 
    		    	    			iconStyle={ { fontSize: TEXT_SIZES.CLOCK}} />

    	    		<IconToggle name="&#xE15A;" onPress={() => this.toolSelected("redo")} 
    	    		    			style={ stylesCarbon.iconosEdition } 
    	    		    			iconStyle={ { fontSize: TEXT_SIZES.CLOCK}} />
				</View>
			</View>*/}
		);
	}

	getBlackboardComp( currentData ){
		//var selectedStyle = {...stylesCarbon.baseIcon, ...{backgroundColor:'#D2D2D2'}}
		var bgColor = this.lc.getColor("background");
		return (
			{/*<View style={styles.blackboardView}>
				<Text style={styles.textEdition}>{languageManager.getLangWord("USEBG")}</Text>
				<TouchableRipple rippleCentered rippleSpread={0.34} style={bgColor=="transparent"?stylesCarbon.baseIcon:selectedStyle} onPress={() => this.toolSelected("bgOn")}>
			       <Image source={require('../assets/buttons/bg.png')} style={{  width: 24, height: 24}} />
			    </TouchableRipple> 

				<TouchableRipple rippleCentered rippleSpread={0.34} style={bgColor=="transparent"?selectedStyle:stylesCarbon.baseIcon} onPress={() => this.toolSelected("bgOff")}>
			       <Image source={require('../assets/buttons/bgOff.png')} style={{  width: 24, height: 24}} />
			    </TouchableRipple> 

			    <RaisedButton style={{...stylesCarbon.button,...{marginLeft: platformHandler.isMobile ? 20:25}}} textStyle={styles.buttonText} onPress={() => this.toolSelected("clear")}>{languageManager.getLangWord("CLEAR")}</RaisedButton>
			    <RaisedButton style={stylesCarbon.button} textStyle={styles.buttonText} onPress={() => this.stopDrawing()}>{languageManager.getLangWord("EXIT")}</RaisedButton>
			</View>*/}
		);
	}

	handleChangeColor = (color) => {
		console.log('change color ' + color)
		this.lastColor = color;
	   this.lc.setColor("primary",color);
	   this.setState({showToolPanel:0})
	}

	receiveCommandFromPlatform( commandData ) {
		switch(commandData.command) 
		{
			case "showDrawTools": 	if(!this.state.editionMode) {
										this.setState({ editionMode:true, pointerMode:false }) 
										this.toolSelected("pencil");				
									}
									break;

			case "showLaserPointer": 	console.log('--> Aca recibe')
										this.setState({ pointerMode:true }) 
										this.activateTool(true);
										break;

			case "showHotPlugin": 	console.log('--> Aca recibe showHotPlugin')
									this.setState({showLoaderInHotPlugin:true});
									break;

			case "closePresentation": 	this.openModal({title:languageManager.getLangWord("CONFIRMATION"),message: languageManager.getLangWord("CONFIRMATION_CLOSE_TEXT")
        								,buttons: [{label:languageManager.getLangWord("YES"),callback:() => this.closePresentation()},{label:languageManager.getLangWord("NO")}]}) 
										break;
		}

	}

	closePresentation = () => { //esta parte de codigo si se cambia tambien hay que cambiarlo en el archivo Auditorium.js
		platformHandler.sendQuestionsToExhibitor();
		platformHandler.closeCurrentSession();
    	platformHandler.openScene("SelectPresentation");
	}

	askRestartClock = () => {
		this.openModal({title:languageManager.getLangWord("CONFIRMATION"),message: languageManager.getLangWord("CONFIRMATION_RESTART_CLOCK")
			,buttons: [{label:languageManager.getLangWord("YES"),callback:() => platformHandler.restartClock()},{label:languageManager.getLangWord("NO")}]})
	}

	closeDrawPanel = () => {
		this.setState({ editionMode:false, pointerMode:false }) 
		this.lc.setTool( new LiterallyCanvas.tools.Eyedropper());
    	this.props.dispatch( setPresentationModeConfig( "showDrawTools", false));
    	this.props.dispatch( setPresentationModeConfig( "showLaserPointer", false));
	}

	Transition(props) {
	  return <Slide direction="left" {...props} />;
	}
		
	getTextSizeOption( i ) {
		const { classes } = this.props;

		let selectedStyle = {
			'filter': 'drop-shadow(0px 0px 1px rgba(0,0,0,0.3)) drop-shadow(0px 0px 10px rgba(0,0,0,0.3))',
			'backgroundColor': '#BBB',
		}

		console.log('thiszzz',this)

		return(
			<Button key={"textSize"+i} id={"textSize"+i} variant="outlined" onClick={() => this.textSizeSelected(i)} className={classes.toolIconButtonOption} style={ (this.state.currentTextSizeSelected==i)?selectedStyle:{} }>
	        	<div className={classes.optionToolImg} style={{fontSize: (this.textToolSizes[i-1]/2)}}>A</div>	        	
	        </Button>
		);		
	}

	getSizeOption( i ){
		const { classes } = this.props;

		let selectedStyle = {
			'filter': 'drop-shadow(0px 0px 1px rgba(0,0,0,0.3)) drop-shadow(0px 0px 10px rgba(0,0,0,0.3))',
			'backgroundColor': '#BBB',
		}

		return(
			<Button key={"size"+i} id={"size"+i} variant="outlined" onClick={() => this.sizeSelected(i)} className={classes.toolIconButtonOption} style={ (this.state.sizeSelected==i)?selectedStyle:{} }>
	        	<Brightness1Icon className={classes.optionToolImg} style={{fontSize: this.strokeWidths[i-1]}}/>
	        </Button>
		);		
	}

	getTextSizeComp() {
		var buttons = [];
		for ( var i = 1; i <= 6; i ++ ){
			buttons.push(
				this.getTextSizeOption(i)
			);
		}

		return (<React.Fragment>{buttons}</React.Fragment>);
	}

	getSizesButtons(){
		var buttons = [];
		for ( var i = 1; i <= 6; i ++ ){
			buttons.push(
				this.getSizeOption(i)
			);
		}

		return (<React.Fragment>{buttons}</React.Fragment>);
	}

	getSVGLine(hasArrow,isDashed) {
		const { classes } = this.props;
		//<line stroke="#000" stroke-dasharray={isDashed?"3,3":""} stroke-linecap="null" stroke-linejoin="null" id="svg_3" y2={hasArrow?5.47331:1.66984} x2={hasArrow?18.71626:22.37529} y1="22.46857" x1="1.48027" stroke-opacity="null" stroke-width="4" fill="none"/>

		let strokeType = null;
		if(isDashed) strokeType={strokeDasharray:'3,3'};

		return (<svg className={classes.fwSvg} viewBox="0 0 24 24" focusable="false">
			{hasArrow && <path transform="rotate(45 18.09037590026856,5.916235923767091) " id="svg_1" d="m15.6109,9.0216l2.47948,-6.21073l2.47948,6.21073l-4.95896,0z" strokeWidth="4" stroke="#000" fill="#000000"/>}
			<line stroke="#000" {...strokeType} strokeLinecap="null" strokeLinejoin="null" id="svg_3" y2={hasArrow?5.47331:1.66984} x2={hasArrow?18.71626:22.37529} y1="22.46857" x1="1.48027" strokeOpacity="null" strokeWidth="4" fill="none"/>
		</svg>);
	}

	toogleWhiteBoardMode() {
		//this.setState({blackboardMode:!this.state.blackboardMode})
		if(this.state.blackboardMode) {
			this.toolSelected("bgOff")
		}
		else {			
			this.toolSelected("bgOn")
		}
	}

	getOrientation() {
		console.log('Pide orientation con ',document.documentElement.offsetWidth,document.documentElement.offsetHeight)
		return document.documentElement.offsetWidth > document.documentElement.offsetHeight?"landscape":"portrait";
	}

	closeHotPlugin = () => {
		platformHandler.deactivateHotPlugin();
		//this.props.dispatch( setPresentationModeConfig("showHotPlugin", null));    	
	}

	getHotPluginInView = () => {

		console.log('--> hot llega con ', this.state.showHotPluginInView)

		if(this.state.showHotPluginInView!==null && this.state.showHotPluginInView!==undefined) {
			

			//Si no se debe mostrar nada en el viewer del exhibitor
			if(this.state.showHotPluginInView.showViewerInExhibitor===false) {
				console.log('Ignora porque el plugin no debe tener vista en exhibidor');
				return;
			}
			
			const { classes } = this.props;		
			var isElectronExhibitor = (platformHandler.isElectron && !platformHandler.isCloud() );
			
			var paramOptional = "";
			if( isElectronExhibitor ){
				paramOptional = "electron=true&";
			}

			paramOptional += "presMode=true&";

			let urlActivity = 'https://app.flipwit.com/plugins/' + this.state.showHotPluginInView.pluginName;

			//TODO2
			urlActivity = urlActivity.replace("plugins", "pluginsTest");

			var urlFinalHotPluginInView = urlActivity + '/viewer/?'+ paramOptional + this.date;

			//urlFinalHotPluginInView = "http://192.168.1.53:3002";

			var style = {backgroundColor: 'white',width:'100%'};

			if(this.state.showHotPluginInView.whiteBackground===false) {
				delete style.backgroundColor;
			}

			console.log('StyleToApply',style);


			return(
				<div className={classes.hotContainer}>
					<WebViewFW ref={(child) => { this.webHotPluginViewer = child; }}
						name={"webHotPluginViewer"}
					    urlWebView={ urlFinalHotPluginInView  }
					    //urlWebView={ "http://localhost:3001/?" + paramOptional + this.date }
					    //urlWebView={ "http://192.168.1.53/flipwit_plugins/static/survey/viewer/?" + this.date }
					    style={style}
					    height={'100%'}					    
					    handleReady={() => {this.setState({showLoader:false})}}
					    handleReceiveMessage={this.onReceiveMessageForHotPluginViewer.bind(this)}					    
				  	/>				  	
				</div>
			);
		}
	}

	getHotPlugin() {

		if(this.state.showHotPluginInView!==null && !platformHandler.isFullScreen()) {

			const { configPresentationMode, classes, currentData } = this.props;		
			//const { classes } = this.props;		
			var isElectronExhibitor = (platformHandler.isElectron && !platformHandler.isCloud() );
			
			var paramOptional = "";
			if( isElectronExhibitor ){
				paramOptional = "electron=true&";
			}

			paramOptional += "presMode=true&";

			let urlActivity = 'https://app.flipwit.com/plugins/' + this.state.showHotPluginInView.pluginName + '/' + this.state.showHotPluginInView.pluginView + '/?';

			/*if(this.state.showHotPluginInView.pluginName==="wordcloud") {
				if(this.state.showHotPluginInView.pluginView==="user") {
					urlActivity = "http://localhost:3001/?";
				}

				if(this.state.showHotPluginInView.pluginView==="viewer") {
					urlActivity = "http://localhost:3002/?";
				}
			}*/

			//TODO2
			urlActivity = urlActivity.replace("plugins", "pluginsTest");

			//if(urlActivity === "https://app.flipwit.com/pluginsTest/surveyQuestions/exhibitor/?") {
			/*if(urlActivity === "https://app.flipwit.com/pluginsTest/surveyAnswers/exhibitor/?") {
			  urlActivity = "http://192.168.1.53:3001/?" + this.date;
			}*/

			let styleDivContainer = {display: 'flex', width: '100%', height: '100%', flexDirection: 'column'};


			var titleHotPlugin = languageManager.getLangWord("HOTPLUGIN_TITLE_"+this.state.showHotPluginInView.pluginName.toUpperCase())

			if(titleHotPlugin === undefined) {
				titleHotPlugin = "";
			}

			titleHotPlugin+=" (" + currentData.sessionCode + ")";
			
			var urlFinalHotPluginLocalDesdeMenu = urlActivity + paramOptional + this.date;

			if (webViewsPrueba.urlFinalHotPluginLocalDesdeMenu !== undefined) {
				urlFinalHotPluginLocalDesdeMenu = webViewsPrueba.urlFinalHotPluginLocalDesdeMenu;
			}
			

			//urlFinalHotPluginLocalDesdeMenu = "http://192.168.1.53:3001";

			return(<React.Fragment>        
			        <Dialog			        
			          open={true}
			          classes={{ paper: classes.paperDialog }}          
			        >
			        	{this.state.showLoaderInHotPlugin && <FwModalLoader />}
			        	<div className={classes.windowBar}>
							<IconButton color="inherit" onClick={() => this.closeHotPlugin()}>
						        	<ArrowBackIcon />				        	
						    </IconButton>
						    <div className={classes.title}>{titleHotPlugin}</div>		    
			        	</div>
			        	<div style={styleDivContainer}>
							<WebViewFW key={this.date} ref={(child) => { this.webHotPlugin = child; }}
								name={"webHotPlugin"}
							    urlWebView={ urlFinalHotPluginLocalDesdeMenu }
							    //urlWebView={ "http://192.168.1.53:3001/?" + this.date }
							    //urlWebView={ "http://192.168.1.53/flipwit_plugins/static/survey/viewer/?" + this.date }
							    style={{backgroundColor: 'white',minHeight: this.state.heightPreview,width:'100%'}}
							    height={'100%'}					    
							    handleReady={() => {this.setState({showLoaderInHotPlugin:false})}}
							    handleReceiveMessage={this.onReceiveMessageForHotPluginHere.bind(this)}					    
						  	/>	
			        	</div>
			        </Dialog>
		    	</React.Fragment>
		   	);
		}
	}

	getDrawPanel() {

		const { configPresentationMode, classes, currentData, dispatch } = this.props;

		if(!configPresentationMode.showDrawTools && !configPresentationMode.showLaserPointer) {
			return;
		}

		console.log("--> ",this.state.heightImg,this.lc)
		if(this.lc) console.log(this.lc.getColor("primary"))

		let contentPreview = this.getImageComp( currentData );
		let tool = this.state.toolSelected;

		let selectedStyle = {
			'filter': 'drop-shadow(0px 0px 1px rgba(0,0,0,0.3)) drop-shadow(0px 0px 10px rgba(0,0,0,0.3))',
			'backgroundColor': '#BBB',
		}

		let styleDivContainer = {display: 'block', width: '100%'};
		let	styleDivContainerInner = {}

		if(configPresentationMode.showLaserPointer) {
			styleDivContainer = {display: 'flex', width: '100%', height: '100%', flexDirection: 'column'};
			styleDivContainerInner = {alignItems: 'center',	display: 'flex', height: '100%'}
		}

		let landscapeOrientation = this.getOrientation()=="landscape";
		
		let useLandscapeCss = landscapeOrientation;

		if(tool==2) {
			useLandscapeCss = this.lastLandscapeOrientation;
		}

		//console.log('useLandscapeCss',useLandscapeCss,landscapeOrientation,tool,this.lastLandscapeOrientation)

		return(<React.Fragment>        
	        <Dialog
	          id="dialogTools"
	          open={configPresentationMode.showDrawTools || configPresentationMode.showLaserPointer}
	          classes={{ paper: classNames(useLandscapeCss && classes.paperDialogLandscape, classes.paperDialog)}}          
	        >
	        	{/*----------------------------------------------------------------------
					PANEL DE OPCIONES PARA HERRAMIENTA (COLOR, GROSOR, ESTILO, TEXTO)
	        	----------------------------------------------------------------------*/}
		        <Dialog
		          open={this.state.showToolPanel > 0}
		          TransitionComponent={this.Transition}
		          classes={{ paper: classes.paperOptionsDialog }}   
		          onClose={() => this.setState({showToolPanel:0})}       
		        >
		        	<div className={classes.paperTitle}>
			            <IconButton
			              color="inherit"
			              aria-label="Open drawer"
			              onClick={() => this.setState({showToolPanel:0})}                
			              className={classes.menuButton}
			              //classes={{label:classes.iconMenuBar}}
			            >
			              <ArrowBackIcon />
			            </IconButton>
			            <div className={classes.labelTitlePaper}>
				            { this.state.showToolPanel == 1 && languageManager.getLangWord('THICKNESS_TITLE')}
							{ this.state.showToolPanel == 2 && languageManager.getLangWord('COLOR_TITLE')}
							{ this.state.showToolPanel == 3 && languageManager.getLangWord('STYLE_TITLE')}
							{ this.state.showToolPanel == 4 && languageManager.getLangWord('TEXTOPT_TITLE')}
			            </div>
			        </div>  
					<div className = {classes.optionsSelectionContainer}>
						{ this.state.showToolPanel == 1 && this.getSizesButtons()}
						{ this.state.showToolPanel == 2 && this.getColorComp()}
						{ this.state.showToolPanel == 3 && this.getStyleComp()}
						{ this.state.showToolPanel == 4 && this.getTextSizeComp()}
					</div>
		        </Dialog>

		        

				{/*----------------------------------------------------------------------
											PANEL DE DIBUJO
	        	----------------------------------------------------------------------*/}
	        	<div style={ styleDivContainer }>
		        	<div className={classes.windowBar}>
						<IconButton color="inherit" onClick={() => this.closeDrawPanel()}>
					        	<ArrowBackIcon />				        	
					    </IconButton>
					    <div className={classes.title}>{this.state.pointerMode?languageManager.getLangWord("LASER_WINDOW_TITLE"):languageManager.getLangWord("DRAW_WINDOW_TITLE")}</div>		    
		        	</div>
		          	<div className={classes.fullImgContainer} style={ styleDivContainerInner }>
		          		{contentPreview}
		          	</div>	  
		        </div>      			        	
	          	{configPresentationMode.showDrawTools && 
		          	<div className={classes.drawToolsContainer}>
			          	<div className={classes.toolsContainer}>
				          	<Button variant="outlined" onClick={() => this.toolSelected("pencil")} className={classes.toolIconButton} style={ (tool==1)?selectedStyle:{} }>
					        	<BrushIcon />
					        </Button>
					        {!landscapeOrientation && <Button variant="outlined" onClick={() => { this.lastOrientation = landscapeOrientation;
					        											this.toolSelected("text")}} 
					        	className={classes.toolIconButton} style={ (tool==2)?selectedStyle:{} }>
					        	<FormatShapesIcon />
					        </Button>}
					        <Button variant="outlined" onClick={() => this.toolSelected("line")} className={classes.toolIconButton} style={ (tool==3)?selectedStyle:{} }>
					        	{this.getSVGLine(true,false)}
					        </Button>
					        <Button variant="outlined" onClick={() => this.toolSelected("square")} className={classes.toolIconButton} style={ (tool==4)?selectedStyle:{} }>
					        	<CropSquareIcon />
					        </Button>
					        <Button variant="outlined" onClick={() => this.toolSelected("ellipse")} className={classes.toolIconButton} style={ (tool==5)?selectedStyle:{} }>
					        	<RadioButtonUncheckedIcon />
					        </Button>
					        <Button variant="outlined" onClick={() => this.toolSelected("eraser")} className={classes.toolIconButton} style={ (tool==6)?selectedStyle:{} }>
					        	<EraserSvg />
					        </Button>
			          	</div>	
			          	<div className={classes.toolsContainer}>
			          		<Button variant="outlined" onClick={() => this.setState({showToolPanel:1})} className={classes.toolIconButton} classes={{label:classes.labelSpan}}>
					        	<div>{languageManager.getLangWord("THICKNESS")}</div> 
					        	<div className={classes.thicknessPreviewDiv}>
					        		<Brightness1Icon className={classes.optionToolImg} style={{fontSize: this.strokeWidths[this.state.sizeSelected-1]}} />				        		
					        	</div>
					        </Button>
					        <Button variant="outlined" onClick={() => this.setState({showToolPanel:2})} className={classes.toolIconButton} classes={{label:classes.labelSpan}}>
					        	<div>{languageManager.getLangWord("COLOR")}</div> 
					        	<div className={classes.thicknessPreviewDiv}>
					        		<div className={classes.optionToolColorImg} style={{width:this.strokeWidths[4],height:this.strokeWidths[4],backgroundColor:this.lc?this.lc.getColor("primary"):'black'}} />
					        	</div>
					        </Button>
					        { tool==2 && <Button variant="outlined" onClick={() => this.setState({showToolPanel:4})} className={classes.toolIconButton} >
					        	<div>{languageManager.getLangWord("TEXT_SIZE")}</div> 
					        	<div className={classes.thicknessPreviewDiv}>
									<div className={classes.optionToolImg} style={{fontSize: (this.textToolSizes[this.state.currentTextSizeSelected-1]/2)}}>A</div>	       					        		
					        	</div>				        	
					        </Button> }
					        { tool==3 && <Button variant="outlined" onClick={() => this.setState({showToolPanel:3})} className={classes.toolIconButton} >
					        	<div>{languageManager.getLangWord("STYLES")}</div> 
					        	<div className={classes.thicknessPreviewDiv}>
									{this.getSVGLine(this.lineTool?this.lineTool.hasEndArrow:false,this.lineTool?this.lineTool.isDashed:false)}				        		
					        	</div>				        	
					        </Button> }
			          	</div>     	
			          	<div className={classes.toolsContainer}>
			          		<Button variant="outlined" onClick={() => this.toolSelected("clear") } className={classes.buttonClear}>
					        	{languageManager.getLangWord("CLEAR")}
					        </Button>
					        <Button variant="outlined" onClick={() => this.toogleWhiteBoardMode()} className={[classes.toolIconButton,classes.toolIconButtonWhiteBoard].join(' ')} style={ (this.state.blackboardMode)?selectedStyle:{} }>
					        	<div>{languageManager.getLangWord("WHITEBOARD_MODE")}</div> <WhiteboardSvg className={classes.svgHide} style={{marginLeft: 4}}/>
					        </Button>
					        <Button variant="outlined" onClick={() => this.toolSelected("undo")} className={[classes.toolIconButton,classes.toolIconButton].join(' ')}>
					        	<UndoIcon />
					        </Button>
					        <Button variant="outlined" onClick={() => this.toolSelected("redo")} className={[classes.toolIconButton,classes.toolIconButton].join(' ')}>
					        	<RedoIcon />
					        </Button>
			          	</div>     	
			          	<div className={classes.toolsContainer}>
			          		<Button variant="contained" onClick={() => {this.closeDrawPanel()} } className={classes.button}>
					        	{languageManager.getLangWord("GO_BACK")}
					        </Button>
			          	</div>     			          	
		          	</div>		
		        }  
		        {!configPresentationMode.showDrawTools && !landscapeOrientation &&
		        	<div className={classes.drawToolsContainer} style={{justifyContent: 'center', minHeight: 180}}>
			          	<div className={classes.toolsContainer} style={{flex: 'none'}}>
			          		<Button variant="contained" onClick={() => this.closeDrawPanel() } className={classes.button}>
					        	{languageManager.getLangWord("GO_BACK")}
					        </Button>
			          	</div>     			          	
		          	</div>
		        }
	        </Dialog>
	      </React.Fragment>    
	    );
	}

	render() {

		
		const { configPresentationMode, classes, currentData, dispatch } = this.props;		
		console.log('Render() Props ',this.props,this.state,currentData)	
		//console.trace();	
    	this.dispatch = dispatch;

    	let contentPreview = null;
    	let contentRight = null;
    	
    	if( currentData.idToglea == ""){

			contentRight = this.getNotesComp( currentData );
			
			//Si esta activo mostrar el panel de dibujo o el de puntero laser entonces
			//en esta vista que es la principal no se debe pintar el lugar de la imagen,
			//pues realmente no es que hayan dos, una directamente en presentationMode y otra
			//en el subpanel de dibujo o laser sino que si estas herramientas estan activas se pasa 
			//el lugar de la imagen solo para el panel
			if(!configPresentationMode.showDrawTools && !configPresentationMode.showLaserPointer) {
    			contentPreview = this.getImageComp( currentData );				
			}			
    	}
    	else{
    		contentPreview = this.getWebViewerComp( currentData );
			contentRight = this.getWebExhibitorComp( currentData );			
    	}
		
		let isNextActive = platformHandler.isNextActive();

    	var textOfCode = languageManager.getLangWord("CODE_CONNECTION") + " - " + currentData.sessionCode;
    	if( platformHandler.isLAN ){
          textOfCode = platformHandler.getUrlApp();
        }
		
		let landscapeOrientation = this.getOrientation()=="landscape";
		

		/*---------------------------------------------------------------------------------------
			Resulta que cuando uno cambia de orientación se cambia la distribucion en los divs, es decir
			cuando esta portrait el lugar donde va la imagen antes iba en el mismo div padre que el lugar 
			de los botones, entonces el contenedor de todos tiene 4 hijos (Imagen, reloj, notas, botones)
			pero cuando se cambia a landscape se crea dentro del contenedor dos divs, el primero con imagen
			y reloj y el segundo con notas y botones, este cambio en la estructura del DOM, hace que el div 
			de la imagen se remueva y se vuelva a poner por parte de React y resulta que el fullscreen va 
			amarrado a un elemento, entonces apenas este se remueve se quita el fullscreen, esto causa por
			ejemplo que en el movil si yo vuelvo fullscree y roto el movil, se salga del full, y en pc puede 
			ser peor, pues si la pantalla es cuadrada la barra del navegador hace que primero sea landscape
			y al volverse fullscreen se vuelva portrait, esto causa que el fullscreen se quite apenas se pone

			entonces lo que hago es que si esta en fullscreen ignore el cambio orientación, pues apenas se 
			regrese a normal el render se llama de nuevo y ahi si funcionaria bien.
		 */
		if(this.lastLandscapeOrientation!=landscapeOrientation && platformHandler.isFullScreen()) {
			landscapeOrientation = this.lastLandscapeOrientation;
		}
		this.lastLandscapeOrientation = landscapeOrientation;

		//---------------------------------------------------------------------------------------

		/* else{
        	contentBottom = ;
        }*/

        //var applyLandscape = this.props.orientation=='landscape'&&platformHandler.isMobile;

		
		let slideContainer = <div id="slideContainer" className={classes.slideImgContainer} ref={(child) => { this.imageCont = child; }}
								onMouseMove={() => {this.tryShowFSTools()}} style={{height: platformHandler.isFullScreen()?'100%':'auto'}}>
								{this.getHotPluginInView()}
								{contentPreview}	
								{this.paintFullScreenTools(currentData)}							
							</div>
		
		
		let slideBarContainer = <div className={[classes.slideBarContainer,classes.allContainers].join(' ')}>
									<Clock askRestartClock={this.askRestartClock}/>
									<div className={classes.fullscreenDiv}>
										{currentData.indexSlide<0?"-":currentData.indexSlide}/{currentData.totalSlides<=0?"-":currentData.totalSlides}
									</div>
									{this.state.fullscreenSupported && <div id="fullScreenBut" className={classes.fullscreenDiv}>
										<Fab
											className={classes.fabFullScreen}
						                  	aria-label="More"
						                  	aria-haspopup="true"
						                  	color="inherit"                
						                  	onClick={this.setFullScreen}  
						                  	//className={classes.subMenuBackButton}
						                >
						              		<FullscreenIcon />
						              	</Fab>							          
							        </div>}
							        {!this.state.fullscreenSupported && <div style={{width:50}}></div>}
								</div>

		
		console.log('Tiene como contentRight',contentRight)

		let notesContainer = 	<div className={[classes.notesContainer,classes.allContainers,classes.bordersNoTop].join(' ')}>		
									<div className={classes.divNotes} ref={(child) => { this.rightCont = child; }}>
										{contentRight}
									</div>
								</div>

		//let widthButtonPrev = document.getElementById("buttonPrevCont").offsetWidth;
		//<div id="buttonPrevCont" className={classes.divForArrows} style={{flex:2,height:widthButtonPrev}}>

		/*let navButtonContainer = 	<div className={[classes.navButtonContainer,classes.allContainers,classes.bordersNoTop].join(' ')}>
										<div id="buttonPrevCont" className={classes.divForArrows} style={{width: widthButtonPrev,height: widthButtonPrev}}>
											<IconButton
												aria-label="More"
								                aria-haspopup="true"
								                color="inherit"                
								                onClick={this.setFullScreen}  
								                className={classes.subMenuBackButton}
							                >
							              		<ArrowBackIcon />
							              	</IconButton>						              	
										</div>
										<div className={classes.divForArrows} style={{width: widthButtonNext,height: widthButtonNext}}>
											<IconButton
							                  aria-label="More"
							                  aria-haspopup="true"
							                  color="inherit"                
							                  onClick={this.setFullScreen}  
							                  className={classes.subMenuBackButton}
							                >
							              		<ArrowForwardIcon />
							              	</IconButton>													
										</div>
									</div>*/

		let styleNavButton = {};

		//En portrait coloca los botones en la parte de abajo
		if(!landscapeOrientation) {
			//styleNavButton = {position: "absolute",bottom: "0"};
		}

		let navButtonContainer = 	<div style={styleNavButton} className={[classes.navButtonContainer,classes.allContainers,classes.bordersNoTop].join(' ')}>
										<div id="buttonPrevCont" className={classes.divForArrows} style={{width: '20%',height: '100%'}}>
											<IconButton
												aria-label="More"
								                aria-haspopup="true"
								                color="inherit"                
								                onClick={() => {this.onButtonPress("Prev", true)}}  
								                className={classes.arrowNavButton}
								                disabled={currentData.indexSlide===1}
								                style={{backgroundColor:(currentData.indexSlide===1?"lightgray":"#FF5722")}}
							                >
							              		<ArrowBackIcon style={{width: '50%',height: '50%'}}/>
							              	</IconButton>						              								              	
										</div>
										<div id="buttonNextCont" className={classes.divForArrows} style={{width: '30%',height: '100%', marginRight: platformHandler.tutorial_start_second_part?"40px":"0px"}}>
											<IconButton
												aria-label="More"
							                	aria-haspopup="true"
							                	color="inherit"                
							                	onClick={() => {this.onButtonPress("Next", true)}}  
							                	className={classes.arrowNavButton}
							                	disabled={currentData.indexSlide===currentData.totalSlides}
							                	style={{backgroundColor:(currentData.indexSlide===currentData.totalSlides?"lightgray":"#FF5722")}}
							                >
							              		<ArrowForwardIcon style={{width: '50%',height: '50%', }}/>
							              	</IconButton>													
										</div>
									</div>

		//-------------------------------------------------------------------------------
		//Para hacer que los botones queden circulares toca por js arreglar el ancho y el alto
		let elementsToFix = ["buttonPrevCont","buttonNextCont"];
		

		if(!this.buttonsFixed) {
			//this.buttonsFixed = true;
			setTimeout(() => {
			elementsToFix.map(
				(el) => {
					let elementCt = document.getElementById(el);

					if(elementCt==null) return;
					
					//console.log("Pasas",elementCt.offsetWidth,elementCt.offsetHeight,this.buttonsFixed)

					if(elementCt.offsetWidth>elementCt.offsetHeight) {
						elementCt.style.width = elementCt.offsetHeight + 'px';
					}
					else {
						elementCt.style.height = elementCt.offsetWidth + 'px';		
					}

					//console.log('sale pasas con ',elementCt.style.width,elementCt.style.height)

					//si esto pasa es porque es un celular que calcula mal los porcentajes
					//como un s5 que vimos
					if(elementCt.style.width=='0px' && elementCt.style.height=='0px') {
						//console.log('pasas3',window.innerWidth,window.innerHeight)
						if(window.innerWidth>window.innerHeight)
						{
							elementCt.style.width = (window.innerHeight*0.3) + 'px';
							elementCt.style.height = (window.innerHeight*0.3) + 'px';							
						}
						else {
							elementCt.style.width = (window.innerWidth*0.3) + 'px';
							elementCt.style.height = (window.innerWidth*0.3) + 'px';													 + 'px'	
						}

						//console.log('Deja final con' ,elementCt.style.width)
						this.buttonsFixed = true;					
						return;
					}

					elementCt.style.visibility = "visible";					
				}
			)
		}, 10)}
		//-------------------------------------------------------------------------------

		console.log('---->>Esto tiene ',this.getHotPlugin(),'con showLoader ->',this.state.showLoader)

		return (
			<React.Fragment>	
				{this.state.showLoader && <FwModalLoader />}
				{this.tutorial.getComponent()}
				{this.getDrawPanel()}
				{this.getHotPlugin()}
				<div className={classes.flipwitContent} ref={(child) => { this.mainDiv = child; }}>
					<div style={{justifyContent:landscapeOrientation?'center':'flex-start'}}className={[classes.allContainers,classes.bigBoxContainers].join(' ')}>
						{!landscapeOrientation && <React.Fragment>
							{slideContainer}
							{slideBarContainer}
							{notesContainer}
							{navButtonContainer}
						</React.Fragment>}
						{landscapeOrientation && <React.Fragment>
						<div className={classes.enclosingDivs}>
							{slideContainer}
							{slideBarContainer}
						</div>
						<div className={classes.enclosingDivs}>
							{notesContainer}
							{navButtonContainer}
						</div>
						</React.Fragment>}
					</div>						
				</div>
			</React.Fragment>
		);
		
		
		/*			
					<View style={styles.centerInfo}>
						
									
									{this.paintFullScreenTools(currentData)}
								</View>
								{contentBottom}								
							</Paper>

							{ !this.state.editionMode &&
								<View style={{flexDirection: "row"}}>
									<View style={styles.button}>
										<RaisedButton style={stylesCarbon.button} textStyle={styles.buttonText} onPress={() => this.onButtonPress("Finish")}>{languageManager.getLangWord("FINISH_PRESENTATION")}</RaisedButton>
									</View>

									<View style={styles.toolButtons}>
										<FloatingActionButton onPress={() => this.onButtonPress("Prev", true)} style={ stylesCarbon.floatingButton }>
											<Icon name="&#xE5C4;" selectable={false} style={stylesCarbon.arrowPrevious} />
										</FloatingActionButton>
										<FloatingActionButton onPress={() => this.onButtonPress("Next", true)} style={ stylesCarbon.floatingButton2 }>
											<Icon name="&#xE5C8;" selectable={false} style={(isNextActive)?stylesCarbon.arrowNext:stylesCarbon.arrowNextDisabled} />
										</FloatingActionButton>
									</View>
								</View>
							}
						</View>

						<View style={styles.rightContainer}>
							<Paper style={stylesCarbon.notes} ref={(child) => { this.rightCont = child; }}>
								{contentRight}
							</Paper>
						</View>	
					</View>
				
				</View>

				
			</View>
		*/			
	}
}

PresentationMode.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object,  
};

PresentationMode.contextTypes = {
  store: PropTypes.object,
};

const mapStateToProps = state => {  	
  return {
  	currentData: selectCurrentData(state),  	
  	configPresentationMode: state.containers.appReducer.configPresentationMode,    
  	language: state.containers.appReducer.language,
  	usersCount: state.containers.appReducer.currentData.usersCount,
  	shareFinish: state.containers.appReducer.configPPT.shareFinish,  	
  }
};

export default connect(mapStateToProps)(withStyles(styles,{ withTheme: true })(PresentationMode));




// WEBPACK FOOTER //
// ./src/containers/scenes/PresentationMode.js